'use strict';

var getQuery = require('./get_query');

module.exports = function () {
  var setLang = getQuery('set_lang');
  return !!setLang;
};